import type { ReactNode } from "react";
import { OfflinePill } from "./OfflineCard";
import { isAdmin, ROLE_LABEL, useMe } from "./session";

export function Header({ children, onSignOut }: { children?: ReactNode; onSignOut?: () => void }) {
  const me = useMe();
  return (
    <header className="topbar">
      <a className="brand" href="#/"><span className="logo" /> Centerline Cloud</a>
      <div className="crumbs">{children}</div>
      <OfflinePill />
      <a className="navlink" href="#/reports">Daily Reports</a>
      {isAdmin(me) && <a className="navlink" href="#/users">Users</a>}
      {me && <a className="whoami small" href="#/profile" title={`${ROLE_LABEL[me.role]} · my profile`}>{me.displayName}</a>}
      {onSignOut && <button className="ghost" onClick={onSignOut}>Sign out</button>}
    </header>
  );
}
